import firebase from "firebase/app";
import "firebase/messaging";

let messaging;

// Defaults match Firebase project zaaapit-48cf4 (settings/localStorage override when present)
const DEFAULT_FIREBASE_CONFIG = {
	apiKey: "AIzaSyCB_kxASCir58ngym0J30x6x0Dbt2qcLQk",
	authDomain: "zaaapit-48cf4.firebaseapp.com",
	projectId: "zaaapit-48cf4",
	messagingSenderId: "596589193992",
	appId: "1:596589193992:web:bcf719f1627254a43b9abd",
};

const DEFAULT_VAPID_KEY =
	"BJNELRbvvf5eWmfUUDM4dRA_-Hw6wQGJgeRz86xMFAGa5k-Rwwf5H6WeFJzGrNgz_nqo0kLS3ylJIoXxyrCk8cs";

if (firebase.messaging.isSupported()) {
	const senderId =
		localStorage.getItem("firebaseSenderId") || DEFAULT_FIREBASE_CONFIG.messagingSenderId;
	const projectId =
		localStorage.getItem("firebaseProjectId") || DEFAULT_FIREBASE_CONFIG.projectId;
	const apiKey = localStorage.getItem("firebaseApiKey") || DEFAULT_FIREBASE_CONFIG.apiKey;
	const appId = localStorage.getItem("firebaseAppId") || DEFAULT_FIREBASE_CONFIG.appId;
	const authDomain =
		localStorage.getItem("firebaseAuthDomain") || DEFAULT_FIREBASE_CONFIG.authDomain;

	if (!firebase.apps.length) {
		firebase.initializeApp({
			apiKey: apiKey,
			authDomain: authDomain,
			projectId: projectId,
			messagingSenderId: senderId,
			appId: appId,
		});
	}

	messaging = firebase.messaging();

	// REQUIRED for v8 - set VAPID key before getToken()
	const vapidKey = localStorage.getItem("firebasePublic") || DEFAULT_VAPID_KEY;

	messaging.usePublicVapidKey(vapidKey);
}

export default messaging;
